export const seoData = {
  home: {
    title: "Beauty Salon at Home in Noida | Luxury Home Salon Services Noida",
    description:
      "Door to Door Beauty provides top-notch salon services with highly trained professionals at your doorstep. Book your first luxury home salon service today at +91-72898 59266.",
    keywords:"salon at home in noida, salon at home noida, parlour at home, beauty parlour services list, salon at home near me, beauticians for doorstep in noida, home salon service in noida, salon at home app, home salon in noida, hair stylist, urban clap salon at home, bridal makeup near me, waxing at home, hair spa at home,beauty parlour services at doorstep,parlour services near me, hair stylist at home , manicure, pedicure, facial, home salon, home parlour service in noida, home service beauty parlour in noida",
    author: "Door to Door Beauty",
  },
  termsConditions: {
    title: "Terms and Conditions | Door to Door Beauty",
    description:
      "Read the Terms and Conditions of Door to Door Beauty to understand the rules, policies, and guidelines governing the use of our premium home salon services.",
    keywords: "terms and conditions, privacy policy, user agreement, Door to Door Beauty policies",
    author: "Door to Door Beauty",
  },
  privacyPolicy: {
    title: "Privacy Policy | Door to Door Beauty",
    description:
      "Learn how Door to Door Beauty collects, uses, and protects your personal information when you use our premium home salon services.",
    keywords: "privacy policy, data protection, personal information, Door to Door Beauty privacy",
    author: "Door to Door Beauty",
  },
  about: {
    title: "About us- Door to Door Beauty",
    description:
      "Door to Door Beauty provides a wide range of salon services at home to trusted women. Our highly trained professional team use Only 100% original and sealed products.",
    keywords: "Home salon services, Salon at Home, Beauty Services at home, Beauty parlour Services at Home, Salon at Home, Home Salon Services, Salon Services at Home, facials, manicure, Pedicure, Waxing. ",
    author: "Door to Door Beauty",
  },
  blog: {
    title: "Door to door Beauty Blog - Read Our Latest Posts",
    description:
      "Explore our latest blogs for in-depth insights on makeup services waxing services, manicure, bridal makeup service, Mehandi, hair studio and other insightful information",
    keywords:
      "beauty blog, makeup tips, waxing guide, bridal beauty, hair care, nail art blog, Door to Door Beauty",
    author: "Door to Door Beauty",
  },
  contact: {
    title: "Contact Us – Door To Door Beauty ",
    description:
      "Contact Door to Door Beauty for personalized salon services and support! We're dedicated to helping you look and feel your best. Let's connect today at +91-72898 59266.!",
    keywords: "contact us, beauty service support, Door to Door Beauty contact, home salon help",
    author: "Door to Door Beauty",
  },
  offers: {
    title: "Beauty Service Offers | Salon Deals at Home",
    description:
      "Check out the latest offers and discounts on luxury beauty services at home. Door to Door Beauty brings affordable pampering to your doorstep.",
    keywords: "beauty offers, home salon deals, salon discounts, Door to Door Beauty offers",
    author: "Door to Door Beauty",
  },
  faqs: {
    title: "FAQs | Home Beauty Services Explained | Door to Door Beauty",
    description:
      "Find answers to common questions about our at-home beauty services. Learn more about booking, hygiene, service areas, and more.",
    keywords: "beauty FAQs, salon at home help, Door to Door Beauty questions",
    author: "Door to Door Beauty",
  },
  gallery: {
    title: "Gallery | Home Salon Service Experience | Door to Door Beauty",
    description:
      "Explore our gallery to see real photos of at-home beauty treatments, satisfied clients, and professional beauticians in action.",
    keywords: "beauty service gallery, salon at home photos, Door to Door Beauty visuals",
    author: "Door to Door Beauty",
  },
  socialProfile: {
    title: "Follow Door to Door Beauty | Connect on Social Media",
    description:
      "Stay connected with Door to Door Beauty. Follow us on social media for updates, beauty tips, customer reviews, and promotions. Let’s connect!",
    keywords: "social media, Door to Door Beauty Facebook, Instagram beauty services, connect online",
    author: "Door to Door Beauty",
  },
  // Add additional pages here
};
